import {styled} from '@mui/system'

export const FistStepStyled = styled('div')(({theme}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  backgroundColor: '#F0F3F4',
  a: {
    color: '#000000de'
  },
  '.login-form-container': {
    boxShadow: '5px 5px 10px rgb(0 0 0 / 5%)',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    width: '600px',
    padding: theme.spacing(8)
  },
  '.img-container': {
    margin: 'auto',
    height: '100px'
  },
  '.img-style': {
    width: '100%',
    height: '100px'
  },
  '.form-container': {
    padding: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column'
  },
  '.form-text': {
    marginBottom: theme.spacing(3)
  },
  '.form-item': {
    paddingBottom: theme.spacing(8),
    display: 'inline-grid'
  },
  '.login-button': {
    color: '#fff',
    borderRadius: theme.spacing(21),
    fontSize: theme.spacing(9),
    fontWeight: 500,
    textTransform: 'none !important',
    height: theme.spacing(27),
    marginBottom: theme.spacing(8)
  },
  '.sponsored-containter': {
    marginTop: theme.spacing(10),
    fontSize: theme.spacing(6),
    alignSelf: 'end',
    display: 'flex',
    alignItems: 'center'
  },
  '.img-images': {
    marginLeft: theme.spacing(2),
    width: theme.spacing(50)
  },
  '.error-message': {
    color: '#f05050',
    textAlign: 'center'
  }
}))
